module.exports = __webpack_public_path__ + "img/mountains.7c680eb5.jpg";